import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../../slices/thunks';
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const forgetSuccessMsg = useSelector((state) => state.ForgetPassword.forgetSuccessMsg);
  const forgetError = useSelector((state) => state.ForgetPassword.forgetError);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      dispatch(forgotPassword({ email: values.email }));
    }
  });

  return (
    <div className="auth-page-content mt-lg-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="mt-4">
              <CardBody className="p-4">
                <div className="text-center mt-2">
                  <h5 className="text-primary">Forgot Password?</h5>
                  <p className="text-muted">Reset password with farmstayhub</p>

                  <lord-icon
                    src="https://cdn.lordicon.com/rhvddzym.json"
                    trigger="loop"
                    colors="primary:#0ab39c"
                    className="avatar-xl"
                    style={{ width: "120px", height: "120px" }}
                  ></lord-icon>
                </div>

                <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                  Enter your email and instructions will be sent to you!
                </Alert>
                <div className="p-2">
                  {forgetError && (
                    <Alert color="danger" style={{ marginTop: "13px" }}>
                      {forgetError}
                    </Alert>
                  )}
                  {forgetSuccessMsg && (
                    <Alert color="success" style={{ marginTop: "13px" }}>
                      {forgetSuccessMsg}
                    </Alert>
                  )}
                  <Form onSubmit={validation.handleSubmit}>
                    <div className="mb-4">
                      <Label className="form-label">Email</Label>
                      <Input
                        name="email"
                        className="form-control"
                        placeholder="Enter email"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email}
                        invalid={
                          validation.touched.email && validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email && validation.errors.email && (
                        <FormFeedback type="invalid">
                          <div>{validation.errors.email}</div>
                        </FormFeedback>
                      )}
                    </div>

                    <div className="text-center mt-4">
                      <button className="btn w-100" style={{ backgroundColor: '#00209f'}} type="submit">
                        Send Reset Link
                      </button>
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>

            <div className="mt-4 text-center">
              <p className="mb-0">
                Wait, I remember my password...
                <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPasswordPage;
